import React from "react";
import AdminMenusRoutes from "./AdminMenusRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminMenusScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Menus",
      page: "Admin Menus Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminMenusRoutes />
      </Track>
    </div>
  );
};

export default AdminMenusScreen;
